import React from 'react';

interface HeatmapEmptyProps {
  message?: string;
}

const HeatmapEmpty: React.FC<HeatmapEmptyProps> = ({ message = 'Connecting to data stream…' }) => (
  <div className="heatmap-container">
    <div className="heatmap-empty">
      <div className="loading-spinner" />
      <p>{message}</p>
    </div>
  </div>
);

export default HeatmapEmpty;
